import { render, staticRenderFns } from "./addWidgets.vue?vue&type=template&id=71899182&scoped=true"
import script from "./addWidgets.vue?vue&type=script&lang=js"
export * from "./addWidgets.vue?vue&type=script&lang=js"
import style0 from "./addWidgets.vue?vue&type=style&index=0&id=71899182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71899182",
  null
  
)

export default component.exports